/**
 * IDs de las monedas
 */
export const Monedas = Object.freeze({
    PESOS: 1,
    DOLARES: 2,
});



// WEBPACK FOOTER //
// ./src/views/Monedas/Monedas/constants.js